<template>
  <div class="inviteMember">
    <el-dialog
      class="customDialog"
      top="15vh"
      title="邀请成员"
      width="480px"
      :visible.sync="isShow"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      @close="close"
    >
      <div class="name">
        <img src="~@/assets/images/team-linka.png" />
        <span>复制链接地址发送给好友.好友可通过链接加入团队</span>
      </div>
      <div class="roleContainer">
        <el-input v-model="link" readonly></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="copy">复制链接</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'inviteMember',
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false
    },
    link: {
      type: String,
      default: ''
    }
  },
  computed: {
    isShow: {
      get: function (v) {
        return this.show
      },
      set: function (v) {
        // 点击关闭按钮更新父组件传过来的参数为false
        this.$emit('update:show', v)
      }
    }
  },
  data () {
    return {}
  },
  mounted () {},
  methods: {
    close () {
      this.isShow = false
    },
    copy () {
      const aux = document.createElement('input')
      aux.setAttribute('value', this.link)
      document.body.appendChild(aux)
      aux.select()
      document.execCommand('copy')
      document.body.removeChild(aux)
      this.$Message('success', '复制成功')
    }
  }
}
</script>

<style lang="scss" scoped>
.inviteMember {
  .name {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    span {
      color: #bbbbbb;
      margin-left: 7px;
    }
  }
  .roleContainer {
    width: 440px;
    height: 112px;
    padding: 0 20px;
    background: rgba($color: #000000, $alpha: 0.3);
    border-radius: 6px;
    display: flex;
    align-items: center;
  }
}
</style>
